import "react-calendar/dist/Calendar.css";
import snackbarUtils from "../../../../../utils/snackbarUtils";
import CircularLoading from "../../../../commons/loadingData/circularLoading";
import { StyledCalendar } from "../../../../styled/calendar";
import CalendarLabel from "./calendarLabel";
import "./reactCalendar.css";
import TileContent from "./tileContent/tileContent";


const CalendarComponent = ({ data, loading, handleClickDay, disabled }) => {

  const getAppointmentsOnDate = (date) => {
    if (!loading) {
      const appointments = [];
      data.forEach((appointment) => {
        if (
          new Date(appointment.fechaHora).toDateString() === date.toDateString()
        ) {
          appointments.push(appointment);
        }
      });
      return appointments;
    }
  };

  return (
    <div>
      {loading ? (
        <StyledCalendar.Loading elevation={2}>
          <CircularLoading />
        </StyledCalendar.Loading>
      ) : (
        <div>
          <StyledCalendar.Calendar
            tileClassName={() => "tile-calendar"}
            view="month"
            tileContent={({ activeStartDate, date, view }) =>
              <TileContent appointments={getAppointmentsOnDate(date)} />
            }
            onClickDay={(date, event) => {
              let appointment = getAppointmentsOnDate(date);
              if (disabled && !appointment.length) {
                snackbarUtils.error(
                  "Funcionalidad agregar turno deshabilitada",
                );
              } else {
                handleClickDay(getAppointmentsOnDate(date), date);
              }
            }}
          />
          <CalendarLabel />
        </div>
      )}
    </div>
  );
};

export default CalendarComponent;
